
import React from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import Footer from "@/components/home/Footer";
import FeatureSection from "@/components/features/FeatureSection";
import FeaturesHero from "@/components/features/FeaturesHero";
import FeatureCTA from "@/components/features/FeatureCTA";

const Features = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Features | Hivetivity - Youth Program Management Software</title>
        <meta 
          name="description" 
          content="Discover Hivetivity's complete youth program management platform with HiveShare secure video sharing, Bill Assist AI billing, HivePad task management, electronic signatures, and more time-saving features." 
        />
        <meta 
          name="keywords" 
          content="youth program features, HiveShare video sharing, Bill Assist AI billing, HivePad task management, electronic signatures, dance studio management, class scheduling, parent communications, automated billing, form designer, check-in kiosk" 
        />
        <link rel="canonical" href="https://hivebubble.com/features" />
      </Helmet>
      
      {/* Top Navigation */}
      <TopNavbar />
      
      {/* Main content */}
      <div className="pt-16">
        {/* Hero Section */}
        <FeaturesHero />
        
        {/* Feature Sections */}
        <FeatureSection />
        
        {/* CTA Section */}
        <FeatureCTA />
        
        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default Features;
